export class DtmCustom {
  events: Array<string>;
  checkout: string;
  reason: string;
  refund: boolean;
  role: string;
  origem: string;

  errorDetail:  string;
  errorMessage: string;
  customLink: string;

  itemClicado: string;

  selectedProduct: string;
  suggestedProduct: string;

  triggeredSecondaryCardAutoSelectFeature: boolean;

  constructor() {
    this.events = new Array<string>();
  }
}
